import axios from 'axios';

const baseURL =
  (import.meta.env as { VITE_API_URL?: string }).VITE_API_URL ?? 'http://localhost:8787';

// Better Auth の cookie で認証するため credentials: include 必須。
export const api = axios.create({
  baseURL,
  withCredentials: true,
});
